export const purpleairStatus = (sensorValue) =>{
    if (sensorValue < 9.1) {
        return 'safe'
    } else {
        if (sensorValue < 35.5) {
            return 'moderate'
        } else {
            if (sensorValue < 55.5) {
                return 'Unhealthy for Sensitive Groups'
            } else {
                if (sensorValue < 125.5) {
                    return 'Unhealthy'
                } else {
                    if (sensorValue <225.5) {
                        return "Very unhealthy"
                    } else {
                        return "Hazardous"
                    }
                }
            }       
        }
    };
}

//---------------------------------------------------------------------------------
export const purpleairDescription = (sensorValue) =>{
    if (sensorValue < 9.1) {
        return 'Air quality is satisfactory, little/no risk'
    } else {
        if (sensorValue < 35.5) {
            return 'Acceptable, but some risk for sensitive groups'
        } else {
            if (sensorValue < 55.5) {
                return 'Sensitive groups may experience health effects'
            } else {
                if (sensorValue < 125.5) {
                    return 'Everyone may begin to experience effects'
                } else {
                    if (sensorValue <225.5) {
                        return 'Health warnings of emergency conditions'
                    } else {
                        return 'Serious health effects for everyone'
                    }
                }
            }       
        }
    };
}

//---------------------------------------------------------------------------------
export const purpleairColor = (sensorValue) =>{
    if (sensorValue < 9.1) {
         //'safe'
         return '#A7D7A9'
    } else {
        if (sensorValue < 35.5) {
            // 'moderate'
            return '#F0E26F'
        } else {
            if (sensorValue < 55.5) {
                // 'Unhealthy for Sensitive Groups'
                return '#FAD7A0'
            } else {
                if (sensorValue < 125.5) {
                    // 'Unhealthy'
                    return '#F5B7B1'
                } else {
                    if (sensorValue <225.5) {
                        // "Very unhealthy"
                        return '#D7BDE2'
                    } else {
                        // "Hazardous"
                        return '#C39BD3'
                    }
                }
            }       
        }
    };
}